'use client';

import { c as _c } from "react/compiler-runtime";
import { DonationIntervals } from 'api-graphql-types/enums';
import classNames from 'classnames';
import { LinkButton, Modal } from 'design-system/client';
import { useTranslations, useLocale } from 'next-intl';
import { isNussbaum } from 'product-analytics';
import { useCallback, useMemo, useState } from 'react';
import styles from './MonthlyMatchingBanner.module.css';
import { ApiRouteNames, useApi } from '@/api';
import I18nHtml from '@/components/I18nHtml';
import { useDonationFormConfig, useDonationFormValues } from '@/donationPages/_dependencies/helpers';
function MonthlyMatchingBanner(t0) {
  const $ = _c(37);
  const {
    className
  } = t0;
  const t = useTranslations("nextjs");
  const [showDetails, setShowDetails] = useState(false);
  const {
    channel,
    receiverId
  } = useDonationFormConfig();
  const locale = useLocale();
  const isNussbaumVersion = isNussbaum(receiverId);
  const t1 = String(receiverId);
  const t2 = isNussbaumVersion ? "true" : "";
  let t3;
  if ($[0] !== locale || $[1] !== t1 || $[2] !== t2) {
    t3 = {
      slug: t1,
      locale,
      isNussbaumVersion: t2
    };
    $[0] = locale;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    data
  } = useApi(ApiRouteNames.apiMatchingEventsProjects, t3);
  const showMonthlyMatching = data && !data.length && channel === "platform";
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = ["interval"];
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const [interval] = useDonationFormValues(t4);
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      setShowDetails(true);
      (document.activeElement as HTMLInputElement | null)?.blur();
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const handleClick = t5;
  const bannerTextKey = interval === DonationIntervals.Monthly ? "donate.monthly_matching_banner_endorsement_html" : "donate.monthly_matching_banner_teaser_html";
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => setShowDetails(false);
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const hideDetails = t6;
  if (!showMonthlyMatching) {
    return null;
  }
  let t7;
  if ($[7] !== className) {
    t7 = classNames(styles.bannerContainer, className);
    $[7] = className;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== bannerTextKey) {
    t8 = <I18nHtml i18nKey={bannerTextKey} />;
    $[9] = bannerTextKey;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t) {
    t9 = t("donate.learn_more");
    $[11] = t;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t9) {
    t10 = <LinkButton className={styles.gentleLink} onClick={handleClick} type="button">{t9}</LinkButton>;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t10 || $[16] !== t8) {
    t11 = <p className={styles.learnMoreText}>{t8}{" "}{t10}</p>;
    $[15] = t10;
    $[16] = t8;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t11 || $[19] !== t7) {
    t12 = <div className={t7}>{t11}</div>;
    $[18] = t11;
    $[19] = t7;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t) {
    t13 = t("donate.monthly_matching_banner_modal_header");
    $[21] = t;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t) {
    t14 = t("core.close");
    $[23] = t;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== t) {
    t15 = t("donate.monthly_matching_banner_modal_content_url");
    $[25] = t;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== t15) {
    t16 = <I18nHtml as="span" i18nKey="donate.monthly_matching_banner_modal_content_html" options={{
      href: t15,
      target: "_blank"
    }} />;
    $[27] = t15;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== showDetails || $[30] !== t13 || $[31] !== t14 || $[32] !== t16) {
    t17 = <Modal id="matching-fund" isOpen={showDetails} onClose={hideDetails} title={t13} closeText={t14} hideActions={true}>{t16}</Modal>;
    $[29] = showDetails;
    $[30] = t13;
    $[31] = t14;
    $[32] = t16;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] !== t12 || $[35] !== t17) {
    t18 = <>{t12}{t17}</>;
    $[34] = t12;
    $[35] = t17;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  return t18;
}
export default MonthlyMatchingBanner;